import React, { Fragment } from "react";
import useAnalyticsEventTracker from '../../../useAnalyticsEventTracker';


const ContactUs = () => {
  const gaEventTracker = useAnalyticsEventTracker('Contact us');
  return (
    <Fragment>
      <section id="contact" className="contact_us">
        <div className="container">
          <div className="row">
            <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
              <h2>Contact Us</h2>
            </div>
            <div className="col-md-4 col-sm-4">
              <h3>Contact Info</h3>
              <div className="space">
                <i
                  className="fa fa-map-marker fa-fw pull-left fa-2x"
                  style={{ height: "80px" }}
                ></i>{" "}
                02/13 Vallabh Flats, Vijay Chowk, NR Sardar Patel Diamond
                Market, Bapunagar, Ahmedabad, Gujarat 380024
              </div>
              <div className="space">
                <p>
                  <i className="fa fa-envelope-o fa-fw pull-left fa-2x"></i>

                  <a href="mailto: customersupport@kabraexpress.com" onClick={()=>gaEventTracker('email')}>
                    customersupport@kabraexpress.com
                  </a>
                </p>
              </div>
              <div className="space">
                <p>
                  <i className="fa fa-phone fa-fw pull-left fa-2x"></i>
                  <a href="tel:+917575857777" onClick={()=>gaEventTracker('call')}>+917575857777</a> <br />{" "}
                  <a href="tel:+919099982886" onClick={()=>gaEventTracker('call')}>+91 9099982886</a>
                </p>
              </div>
            </div>
            <div className="col-md-8 col-sm-8 marb20">
              <div className="contact-info">
                <h3 className="cnt-ttl">
                  Having Any Query! Or Book an appointment
                </h3>
                <div className="space"></div>
                <div id="sendmessage">
                  Your message has been sent. Thank you!
                </div>
                <div id="errormessage"></div>
                <form
                  action=""
                  method="post"
                  role="form"
                  className="contactForm"
                >
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control br-radius-zero"
                      id="name"
                      placeholder="Your Name"
                      data-rule="minlen:4"
                      data-msg="Please enter at least 4 chars"
                    />
                    <div className="validation"></div>
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control br-radius-zero"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      data-rule="email"
                      data-msg="Please enter a valid email"
                    />
                    <div className="validation"></div>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control br-radius-zero"
                      name="subject"
                      id="subject"
                      placeholder="Subject"
                      data-rule="minlen:4"
                      data-msg="Please enter at least 8 chars of subject"
                    />
                    <div className="validation"></div>
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control br-radius-zero"
                      name="message"
                      rows={5}
                      data-rule="required"
                      data-msg="Please write something for us"
                      placeholder="Message"
                    ></textarea>
                    <div className="validation"></div>
                  </div>

                  <div className="form-action">
                    <button type="submit" className="btn got-started">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ContactUs;
